<!-- 范围列表 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getDataList" :showRefresh="true" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="类型名称">
                        <label slot="label" :style="$common.labelStyle('类型名称')" v-html="$common.htmlLabel('类型名称')"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.surgeryName" clearable :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="lineCode" label="线路编号"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="lineName" label="线路名称"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="lineType" label="线路类型"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="lineDesc" label="线路描述"></el-table-column>
            </el-table>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="actionData.title" v-if="showStatus" :visible.sync="showStatus" width="400px">
            <el-form :model="sendDataInfo" ref="sendDataInfo" label-width="100px" class="demo-ruleForm" :inline-message="false" :show-message="false">
                <el-form-item label="线路编号" prop="lineCode" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-input class="line_input" type="text" v-model="sendDataInfo.lineCode" clearable></el-input>
                </el-form-item>
                <el-form-item label="线路名称" prop="lineName" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-input class="line_input" type="text" v-model="sendDataInfo.lineName" clearable></el-input>
                </el-form-item>
                <el-form-item label="线路类型" prop="lineType" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-select class="line_input" v-model="sendDataInfo.lineType" placeholder="请选择">
                        <el-option label="A" value="A"></el-option>
                        <el-option label="B" value="B"></el-option>
                        <el-option label="C" value="C"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="终端客户" prop="tcmName" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-input clearable v-model="sendDataInfo.tcmName" @keyup.enter.native="openSearch(938101838391, 0, 'tcmName', 'tcmName,tcmId')">
                        <el-button @click="openSearch(938101838391, 0, 'tcmName', 'tcmName,tcmId')" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="医院" prop="hospitalName" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-input clearable v-model="sendDataInfo.hospitalName" @keyup.enter.native="openSearch(8193891732838791, 0, 'hospitalName', 'hospitalName,hospitalId')">
                        <el-button @click="openSearch(8193891732838791, 0, 'hospitalName', 'hospitalName,hospitalId')" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="线路描述" prop="lineDesc">
                    <el-input class="line_input" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="sendDataInfo.lineDesc" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showStatus = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit('sendDataInfo')">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                surgeryName: "",
            },
            returnData: {
                list: [],
            },
            buttonList: [
                {
                    jurName: "新增",
                    actionType: 0,
                },
                {
                    jurName: "修改",
                    actionType: 1,
                },
                {
                    jurName: "删除",
                    actionType: 2,
                },
            ],
            selectedDataIndex: 0,
            seId: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            showStatus: false,
            actionData: {
                title: "",
                type: "",
            },
            sendDataInfo: {
                lineCode: "",
                lineName: "",
                lineType: "",
                tcmName: "",
                tcmId: "",
                lineDesc: "",
                hospitalName: "",
                hospitalId: ""
            }
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.tcmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.sendDataInfo.tcmId = ""
                }
            },
            deep: true,
        },
        "sendDataInfo.hospitalName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.sendDataInfo.hospitalId = ""
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        init() {
            this.sendDataInfo = {
                remark: "",
                lineCode: "",
                lineName: "",
                lineType: "",
                tcmName: "",
                tcmId: "",
                lineDesc: "",
                hospitalName: "",
                hospitalId: ""
            }
        },
        // 子组件触发
        drawerCancel() {
            this.showStatus = false;
            this.getDataList();
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.parentSearchData = {}
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        //返回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'tcmName') {
                    this.sendDataInfo.tcmName = val.tcmName;
                    this.sendDataInfo.tcmId = val.tcmId;
                } else if (this.seType == 'hospitalName') {
                    this.sendDataInfo.hospitalName = val.hospitalName;
                    this.sendDataInfo.hospitalId = val.hospitalId;
                } else {
                    this.getRequestData.scopeName = val.scopeName;
                    this.getRequestData.opmId = val.opmId;
                }
            }
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.init()
                    this.showStatus = true;
                    this.actionData = {
                        title: "新增",
                        type: 0,
                    }
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    for (const key in this.sendDataInfo) {
                        if (dataInfo[key]) {
                            this.sendDataInfo[key] = dataInfo[key];
                        }
                    }
                    this.showStatus = true;
                    this.actionData = {
                        title: "修改",
                        type: 1,
                    }
                    break;
                case 2:
                    this.delDataAction();
                    break;
            }
        },
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sub()
                } else {
                    this.$message.error("请完善必填项！")
                    return false;
                }
            });
        },
        async sub() {
            let responseData;
            let sendData = {}
            if (this.actionData.type === 0) {
                sendData = {
                    ...this.sendDataInfo,
                }
                responseData = await this.$http.terminalLineadd(sendData)
            } else if (this.actionData.type === 1) {
                sendData = {
                    ...this.sendDataInfo,
                    lineId: this.returnData.list[this.selectedDataIndex].lineId,
                }
                responseData = await this.$http.terminalLinemodify(sendData)
            }
            if (responseData.status == 200) {
                this.showStatus = false
                this.getDataList()
                this.$message.success(responseData.message)
            } else {
                this.$message.error(responseData.message)
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.lineId],
                };
                let responseData = await this.$http.terminalLinedelete(delData);
                if (responseData.status == 200) {
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    });

                    this.getDataList();
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            })
                .catch(() => { });
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.terminalLinequeryAll(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result)
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
.line_input {
    width: 260px;
}
</style>
